import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/store";
import { useGetMeQuery } from "../features/auth/authApi";
import { userLoggedIn } from "../features/auth/authSlice";
import useError from "./useError";

export default function useAppBoot() {
  const { access_token, role, notificationToken } = useAppSelector(
    (state) => state.auth
  );
  const dispatch = useAppDispatch();
  const { keycloak, initialized } = useKeycloak();
  const [search] = useSearchParams();

  useEffect(() => {
    if (initialized && keycloak?.token) {
      dispatch(
        userLoggedIn({
          access_token: keycloak.token,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized, keycloak.token, notificationToken]);

  const { isLoading, isError, error } = useGetMeQuery(undefined, {
    skip: !access_token,
  });
  useError(isError, error, "Get me details fail");

  useEffect(() => {
    const type = search.get("type");
    const dynamicId = search.get("dynamic-id");
    const dynamicKeyword = search.get("dynamic-keyword");

    if (type) {
      localStorage.setItem("product-type", JSON.stringify(type));
    }

    if (dynamicId && dynamicKeyword) {
      localStorage.setItem(
        "dynamic",
        JSON.stringify({
          dynamicId,
          dynamicKeyword,
        })
      );
    }
  }, [search]);

  const isAppLoading = !initialized || isLoading;

  const navigateUrl =
    role === "admin" ? "/admin/dashboard" : "/organization/dashboard";

  return { loading: isAppLoading, navigateUrl };
}
